import {
  ConfigTypes,
  BuilderTypes,
  TitleAlign,
} from "@/api/AppApi/common-interfaces/api-enums";
export enum CategoryStyleTypes {
  circle_icon = "circle_icon", //default
  circle_img = "circle_img",
  square = "square",
  square_primary = "square_primary",
  square_primary_title = "square_primary_title",
}
export interface IProduct_Category_Config_Customize {
  advance_mode: boolean;
  align: string;
  background_color: string;
  font_size: number;
  font_size_mobile: number;
  gap: number;
  gap_mobile: number;
  height: number;
  height_mobile: number;
  interval: number;
  justify: string;
  slide_num: number;
  slide_num_mobile: number;
  width: number;
  width_mobile: number;
  show_price: boolean;
}

export interface IProduct_Scrollable_Tabs_Config_Customize {
  image_position: "start" | "end";
}
export type Config_Customize =
  | IProduct_Category_Config_Customize
  | IProduct_Scrollable_Tabs_Config_Customize;
export interface ICategory {
  icon: string;
  id: number;
  image: string;
  name: string;
  subcategories_count: number;
  slug: string;
}
export interface ICategories {
  index?: number;
  type?: BuilderTypes.category;
  configurations?: {
    customize?: IProduct_Category_Config_Customize;
    title?: string;
    target_url?: string;
    type: ConfigTypes;
    title_align?: TitleAlign;
    style_type: CategoryStyleTypes;
    // interval?: number; //not in api
    view_all?: boolean;
  };
  data: ICategory[];
}
